{
  "qr-checkin-config-page": {
    "buttons": {
      "check-in": "CHECK IN"
    },
    "meta": {
      "title": "QR Check in",
      "description": "Check in pomocí QR kódu",
      "checkin-hint": "(Volitelné) Službu si můžete vybrat před check-in"
    }
  }
}
